(function () {
  if (window.wwOrderMethodLoaded) return;
  window.wwOrderMethodLoaded = true;

  const PUBLIC_TOKEN = 'c4e2425210a081d90b89bf781980a4ad';
  const STORE_DOMAIN = 'shop.waterworldusa.com';
  const API_VERSION = '2026-10';
  const PICKUP_LOCATION = '103109755181';

  const STORAGE_KEY = 'ww_order_method';
  const CONFIRM_KEY = 'ww_pickup_confirmed';

  let method =
    sessionStorage.getItem(STORAGE_KEY) === 'pickup'
      ? 'pickup'
      : 'shipping';

  let confirmed =
    sessionStorage.getItem(CONFIRM_KEY) === 'yes';

  let processing = false;
  let savePromise = Promise.resolve();

  function cartPath(path) {
    return (window.Shopify?.routes?.root || '/') + path;
  }

  function asAttributes(object) {
    return Object.entries(object || {})
      .filter(([, value]) =>
        value !== null && value !== undefined
      )
      .map(([key, value]) => ({
        key,
        value: String(value)
      }));
  }

  function saveCartAttributes() {
    const attributes = {
      'Order Method':
        method === 'pickup'
          ? 'In-store pickup'
          : 'Ship to my address',

      'Pickup Confirmation':
        method === 'pickup' && confirmed
          ? 'Confirmed'
          : 'Not applicable'
    };

    // Save sequentially so older requests cannot overwrite
    // a newer selection.
    const request = savePromise
      .catch(() => {})
      .then(async function () {
        const response = await fetch(
          cartPath('cart/update.js'),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ attributes })
          }
        );

        if (!response.ok) {
          throw new Error('Unable to save order method.');
        }

        return response.json();
      });

    savePromise = request;
    return request;
  }

  function persistSelection() {
    sessionStorage.setItem(STORAGE_KEY, method);
    sessionStorage.setItem(
      CONFIRM_KEY,
      confirmed ? 'yes' : 'no'
    );
  }

  function updateUI() {
    document.querySelectorAll('.ww-order-method')
      .forEach(function (section) {
        const shippingRadio = section.querySelector(
          'input[value="shipping"]'
        );

        const pickupRadio = section.querySelector(
          'input[value="pickup"]'
        );

        const confirmation = section.querySelector(
          '.ww-pickup-confirmation'
        );

        const checkbox = section.querySelector(
          '.ww-pickup-checkbox'
        );

        const message = section.querySelector(
          '.ww-order-message'
        );

        if (shippingRadio) {
          shippingRadio.checked = method === 'shipping';
          shippingRadio.disabled = processing;
        }

        if (pickupRadio) {
          pickupRadio.checked = method === 'pickup';
          pickupRadio.disabled = processing;
        }

        if (confirmation) {
          confirmation.hidden = method !== 'pickup';
        }

        if (checkbox) {
          checkbox.checked =
            method === 'pickup' && confirmed;
          checkbox.disabled = processing;
        }

        if (message) {
          message.hidden = true;
        }
      });
  }

  function showConfirmationMessage(button) {
    const container = button.closest(
      '.drawer__footer, #main-cart-footer'
    );

    const section =
      container?.querySelector('.ww-order-method') ||
      Array.from(
        document.querySelectorAll('.ww-order-method')
      ).find(element => element.getClientRects().length);

    const message = section?.querySelector(
      '.ww-order-message'
    );

    if (message) {
      message.hidden = false;
      message.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      alert('Please confirm your in-store pickup selection.');
    }
  }

  function lineSignature(
    merchandiseId,
    quantity,
    attributes
  ) {
    const sortedAttributes = attributes
      .map(attribute => [
        attribute.key,
        attribute.value
      ])
      .sort((a, b) =>
        a[0].localeCompare(b[0]) ||
        a[1].localeCompare(b[1])
      );

    return JSON.stringify([
      merchandiseId,
      quantity,
      sortedAttributes
    ]);
  }

  async function createPreferredCheckout(
    sourceCart,
    selectedMethod
  ) {
    if (
      !PUBLIC_TOKEN ||
      PUBLIC_TOKEN === 'PASTE_PUBLIC_TOKEN_HERE'
    ) {
      throw new Error(
        'Please add your public Storefront API token.'
      );
    }

    if (!sourceCart.items?.length) {
      throw new Error('Your cart is empty.');
    }

    // First test: ordinary products without subscriptions,
    // bundles, or discounts.
    if (
      sourceCart.items.some(item =>
        item.selling_plan_allocation ||
        item.item_components?.length ||
        item.parent_relationship
      )
    ) {
      throw new Error(
        'Please test with a regular product without ' +
        'subscriptions or bundles.'
      );
    }

    if (
      sourceCart.total_discount > 0 ||
      sourceCart.discount_codes?.length
    ) {
      throw new Error(
        'Please remove discounts for this first checkout test.'
      );
    }

    if (sourceCart.items.length > 250) {
      throw new Error(
        'Too many cart lines for this checkout test.'
      );
    }

    const delivery = {
      deliveryMethod: [
        selectedMethod === 'pickup'
          ? 'PICK_UP'
          : 'SHIPPING'
      ]
    };

    if (selectedMethod === 'pickup') {
      delivery.pickupHandle = [PICKUP_LOCATION];
    }

    const buyerIdentity = {
      preferences: { delivery }
    };

    if (window.Shopify?.country) {
      buyerIdentity.countryCode = window.Shopify.country;
    }

    const input = {
      lines: sourceCart.items.map(item => ({
        merchandiseId:
          'gid://shopify/ProductVariant/' +
          item.variant_id,
        quantity: item.quantity,
        attributes: asAttributes(item.properties)
      })),
      attributes: asAttributes(sourceCart.attributes),
      note: sourceCart.note || '',
      buyerIdentity
    };

    const response = await fetch(
      'https://' + STORE_DOMAIN +
      '/api/' + API_VERSION + '/graphql.json',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token':
            PUBLIC_TOKEN
        },
        body: JSON.stringify({
          query: `
            mutation WWCreateCheckout($input: CartInput!) {
              cartCreate(input: $input) {
                cart {
  checkoutUrl
  buyerIdentity {
    preferences {
      delivery {
        deliveryMethod
        pickupHandle
      }
    }
  }
  deliveryGroups(first: 10) {
    nodes {
      deliveryOptions {
        deliveryMethodType
        title
      }
      selectedDeliveryOption {
        deliveryMethodType
        title
      }
    }
  }
  lines(first: 250) {
                    nodes {
                      quantity
                      merchandise {
                        ... on ProductVariant {
                          id
                        }
                      }
                      attributes {
                        key
                        value
                      }
                    }
                  }
                }
                userErrors {
                  message
                }
                warnings {
                  message
                }
              }
            }
          `,
          variables: { input }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        'Storefront API request failed (' +
        response.status + ').'
      );
    }

    const result = await response.json();

    if (result.errors?.length) {
      throw new Error(
        result.errors
          .map(error => error.message)
          .join('\n')
      );
    }

    const payload = result.data?.cartCreate;

    const problems = [
      ...(payload?.userErrors || []),
      ...(payload?.warnings || [])
    ];

    if (problems.length) {
      throw new Error(
        problems
          .map(problem => problem.message)
          .join('\n')
      );
    }

    const checkoutCart = payload?.cart;

    if (!checkoutCart?.checkoutUrl) {
      throw new Error(
        'Shopify did not return a checkout URL.'
      );
    }

    // Check that no product, quantity, or property was lost.
    const expected = input.lines
      .map(line =>
        lineSignature(
          line.merchandiseId,
          line.quantity,
          line.attributes
        )
      )
      .sort();

    const actual = checkoutCart.lines.nodes
      .map(line =>
        lineSignature(
          line.merchandise.id,
          line.quantity,
          line.attributes
        )
      )
      .sort();

    if (
      JSON.stringify(expected) !==
      JSON.stringify(actual)
    ) {
      throw new Error(
        'Checkout items differ from your cart. ' +
        'Please review product availability.'
      );
    }

return checkoutCart.checkoutUrl;
  }

  document.addEventListener('change', function (event) {
    const target = event.target;

    if (!(target instanceof Element)) return;

    if (
      target.matches(
        '.ww-order-method input[name="ww_order_method"]'
      )
    ) {
      if (processing) {
        updateUI();
        return;
      }

      method =
        target.value === 'pickup'
          ? 'pickup'
          : 'shipping';

      confirmed = false;

      persistSelection();
      updateUI();

      saveCartAttributes().catch(error => {
        console.error('WaterWorld cart update:', error);
      });
    }

    if (target.matches('.ww-pickup-checkbox')) {
      if (processing) {
        updateUI();
        return;
      }

      confirmed = target.checked;

      persistSelection();
      updateUI();

      saveCartAttributes().catch(error => {
        console.error('WaterWorld cart update:', error);
      });
    }
  });

  async function startCheckout(button) {
    if (processing) return;

    if (method === 'pickup' && !confirmed) {
      showConfirmationMessage(button);
      return;
    }

    processing = true;

    const wasDisabled = button.disabled;
    const selectedMethod = method;

    button.disabled = true;
    button.dataset.wwProcessing = 'true';
    updateUI();

    try {
      const sourceCart = await saveCartAttributes();

      const checkoutUrl = await createPreferredCheckout(
        sourceCart,
        selectedMethod
      );

      window.location.assign(checkoutUrl);
    } catch (error) {
      console.error('WaterWorld checkout:', error);

      processing = false;
      button.disabled = wasDisabled;
      button.dataset.wwProcessing = 'false';
      updateUI();

      alert(
        error.message ||
        'Unable to open checkout. Please try again.'
      );
    }
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(
      '#CartDrawer-Checkout, #checkout'
    );

    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    startCheckout(button);
  }, true);

  // Also handle checkout submitted through the keyboard.
  document.addEventListener('submit', function (event) {
    const button = event.submitter;

    if (
      !button?.matches(
        '#CartDrawer-Checkout, #checkout'
      )
    ) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    startCheckout(button);
  }, true);

  // Keep the selection after Shopify refreshes the drawer.
  const observer = new MutationObserver(function () {
    updateUI();
  });

  function init() {
    updateUI();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Restore usable controls when returning from checkout.
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;

      processing = false;

      document.querySelectorAll(
        '[data-ww-processing="true"]'
      ).forEach(function (button) {
        button.disabled = false;
        button.dataset.wwProcessing = 'false';
      });

      updateUI();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();